<template>
    <b-modal :active.sync="isActive"
             has-modal-card full-screen >
        <div class="modal-card">
            <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
            <header class="modal-card-head">
                <p class="modal-card-title"> {{PathogenSelect}}
                    <span class="tag is-warning">  {{idlab}}</span>

                </p>


                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <p class="modal-card-title">
                    <b-button type="is-success"
                              icon-right="plus"
                              @click="addPathogen" > </b-button>
                </p>



                <b-table
                        :data="dataResultSet"
                        :bordered=false
                        :striped=false
                        narrowed
                        :hoverable=false
                        :focusable=false
                        mobile-cards>


                    <b-table-column   label="Pathogen"   v-slot="props">

                        <h3 class="subtitle is-5"> {{ props.row.title }}</h3>
                    </b-table-column>




                    <b-table-column   label="Result"   >
                        <template v-slot:header="{ column }">
                            {{ column.label }}
                            <span class="has-text-danger">*</span>
                        </template>
                        <template v-slot="props">
                            <b-select placeholder="Select a result"
                                      v-model="props.row.result_dat"
                                   >
                                <option
                                        v-for="result_aval in props.row.result_aval"
                                        :value="result_aval"
                                        :key="result_aval">
                                    {{ result_aval }}
                                </option>
                            </b-select>
                        </template>


                    </b-table-column>

                    <b-table-column   label="Remark"  v-slot="props">
                        <b-field  :type="{ 'is-danger':   props.row.comment_each.length>GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH  }"
                                  :message= "{ 'Max Over range' :   props.row.comment_each.length>GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH   }"  expanded>
                            <b-input v-model="props.row.comment_each" >{{ props.row.comment_each }} </b-input>
                            <template slot="message">
                                <span class="has-text-primary is-italic" v-if="props.row.comment_each">({{props.row.comment_each.length}}/{{GLOBAL_VAR.MAX_CHAR_PCR_COMMENT_EACH}})</span>
                            </template>
                        </b-field>
                    </b-table-column>


                    <b-table-column   label="#"  v-slot="props">
                        <b-button type="is-danger"
                                  icon-left="delete"
                                  @click="deleteItemPathogen( props.row.id)">
                            Delete
                        </b-button>
                    </b-table-column>
                </b-table>
            </section>
            <footer class="modal-card-foot">
                <!--                <button class="button is-danger"   @click="closeBtn" >Cancel</button>-->
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveBtn" >Save </b-button>
            </footer>

            <SelectPathogen
                    v-if="isSelectPathogenShowing"
                    :isComponentModalActive="isSelectPathogenShowing"
                    @close="closeSelectPathogen"
                    @closeWithSelectItem="closeWithSelectItem"
            />
        </div>
    </b-modal>
</template>

<script>
    import globalconst from "../../../mixins/globalconst";
    import SelectPathogen from "../SelectPathogen";
    import {   MAX_CHAR_PCR_COMMENT_EACH , genUUID  , getBaseURLforBackEnd , getConfigAxios }  from '@/utils.js'
    import axios from "axios";
    import { mapState } from "vuex";

    export default {
        name: "PlusPathogen",
        components:{
            SelectPathogen
        },
        mixins:[globalconst],
        props:{
            idlab : String,
            isShowing : Boolean,
        },
        computed:{
            ...mapState({
                access_token: state => state.master_data.access_token,
            }),
            GLOBAL_VAR(){
                return { MAX_CHAR_PCR_COMMENT_EACH }
            },
        },
        data(){
            return {
                isActive : true,
                isModalSelectPathogen : false,
                isSelectPathogenShowing : false,
                isFullScreenSearching : false,

                dataResultSet : []  ,  //   [{"idpathogen": "","title":"", "result_dat": "","result_aval": [ "Negative","Positive" ],"comment_each": "", "user_rec_id" : 1 ,  "user_rec_fn" : "" , "datetime_rec" : "" , "id": ""  } ...] ,
            }
        },
        methods:{

            closeSelectPathogen(){
                this.isSelectPathogenShowing = false
            },

            closeWithSelectItem(payload){
                // console.log(JSON.stringify(payload))

                this.dataResultSet.push( {
                    "id" : genUUID(5),
                    "idpathogen":  payload.id,
                    "title": payload.title,
                    "result_dat":null,
                    "result_aval": payload.result_dat_aval.id,
                    "comment_each":""
                })
                this.isSelectPathogenShowing = false

            },




            closeBtn(){
              this.$emit('closePlusPathogen')
            },

            checkDataValid(){

                for(var i =0;i< this.dataResultSet.length ; i ++){
                    if(this.dataResultSet[i].result_dat===null){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Field Result Require but empty',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return false
                    }
                }


                return true

            },



            saveBtn(){




            if(this.dataResultSet.length===0){
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: `don't have data to proceed`,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return 0
            }

            if( this.checkDataValid() ) {
                  const tmpArr = this.dataResultSet.map(dat=>{
                      return {
                          "idpathogen": dat.idpathogen ,
                          "result_dat": dat.result_dat,
                          "comment_each": dat.comment_each
                      }
                  })

                const  datTo = {
                       "idlab": this.idlab ,
                       "data": tmpArr

                   }

                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                axios.post(`${getBaseURLforBackEnd()}/api/newinsertpathogenplus`, datTo, getConfigAxios())
                      .then((res)=>{
                          vm.$buefy.toast.open({
                              message:  `${res.data.msg}`,
                              type: 'is-success'
                          })

                          vm.$emit('closePlusPathoge_WithChange')

                      })
                      .catch((err)=>{
                          this.$buefy.dialog.alert({
                              title: 'Error',
                              message: `${err.message}`,
                              type: 'is-danger',
                              hasIcon: true,
                              icon: 'times-circle',
                              iconPack: 'fa',
                              ariaRole: 'alertdialog',
                              ariaModal: true
                          })
                      })

            }




            },
            addPathogen(){
                this.isSelectPathogenShowing = true
            },
            deleteItemPathogen(_id){
                const member = this.dataResultSet.find(dat=>{
                    return dat.id === _id
                })

                const memberIndex = this.dataResultSet.indexOf(member)
                this.dataResultSet.splice(memberIndex,1)
            }
        }
    }
</script>

<style scoped>

</style>